import { render } from "./OpenSource.vue?vue&type=template&id=6b659c3f&scoped=true"
import script from "./OpenSource.vue?vue&type=script&lang=js"
export * from "./OpenSource.vue?vue&type=script&lang=js"

import "./OpenSource.vue?vue&type=style&index=0&id=6b659c3f&scoped=true&lang=css"

import exportComponent from "../../.yarn/__virtual__/vue-loader-virtual-6763a87ef6/0/cache/vue-loader-npm-17.4.2-00674d01e5-ffbe3e848e.zip/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b659c3f"]])

export default __exports__